export default __webpack_public_path__ + "static/210519_魔獄塔更新熱更預告_sc-21e023c1e283695f3d5cdb00f1f72421.webp";